"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgSend02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12.704 1.875a1.5 1.5 0 0 0-1.33-.002c-.37.182-.563.501-.657.667-.1.179-.204.407-.307.635L2.826 19.958a8.654 8.654 0 0 0-.28.663c-.062.18-.177.543-.066.946a1.5 1.5 0 0 0 .897.995c.389.153.762.076.948.033a8.67 8.67 0 0 0 .688-.21l4.891-1.623c.394-.13.591-.196.737-.318a1 1 0 0 0 .29-.4c.069-.178.069-.385.069-.8V12a1 1 0 1 1 2 0v7.225c0 .414 0 .621.07.797a1 1 0 0 0 .288.401c.145.122.341.188.734.32l4.895 1.638c.243.081.486.162.688.21.185.045.558.122.947-.03a1.5 1.5 0 0 0 .9-.992c.112-.402-.001-.765-.063-.946a8.665 8.665 0 0 0-.277-.663L13.662 3.18c-.102-.228-.204-.457-.305-.636-.093-.166-.286-.486-.654-.67Z", fill: "currentColor" }) }))); };
exports.default = SvgSend02;
